module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "the-kid-from-port-douglas"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "120px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "4.63in",
      "height": "3.19167in"
    },
    attrs: {
      "alt": "",
      "src": "media/file0.jpg"
    }
  })]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("When the Cobb and Co coach returned to port Douglas in the early sixties, Grandma was not to be denied the experience as she was born hardly 100 meters from where the coach stood. My sister and I accompanied her in the coach. It was a special day.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdde7154","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0001.vue
// module id = 75
// module chunks = 0